<template>
    <div>
        <div v-if="menus.length">
            <portal to="navbar-list">
                <navbar :site-slug="siteSlug" :menus="menus"></navbar>
            </portal>
            <portal to="cart">
                <cart :site-slug="siteSlug" :cart="cart" cart-type="home"></cart>
            </portal>

            <div class="container">
                <banner location="home-top"></banner>

                <div class="small text-danger mt-3" v-if="inactiveMessage">{{ inactiveMessage }}</div>

                <menu-section-listing v-for="(menu, key) in menus" :key="menu.id" :menu="menu" :site-slug="siteSlug">
                    <banner location="home-middle" v-if="key == 0 && menus.length > 1"></banner>
                </menu-section-listing>

                <banner location="home-bottom"></banner>
            </div>
        </div>

        <vue-alert class="mt-4" type="warning" v-else-if="(cart && (cart.variant != 'click-and-collect' || cart.slot_id)) && error.length">{{ error }}</vue-alert>

        <div class="container" v-else-if="!cart && Object.keys(enabledMenus).length > 1">
            <div class="mt-5 row">
                <div class="col-12 col-md-8 offset-0 offset-md-2">
                    <h5 class="mb-3">{{ $t("Please select an option from below:") }}</h5>
                    <div class="d-flex justify-content-between flex-column flex-md-row">
                        <a class="btn btn-lg py-2 variant-button mr-3 d-flex justify-content-between align-items-center w-100 mb-2 mb-md-0 eat-in-button" :href="`/${siteSlug}/eat-in`">
                            {{ $t("Eat-in") }}
                            <i class="fas fa-utensils"></i>
                        </a>
                        <a class="btn btn-lg py-2 variant-button d-flex justify-content-between align-items-center w-100 click-and-collect-button" :href="`/${siteSlug}/click-and-collect`">
                            {{ $t("Click and collect") }}
                            <i class="fas fa-shopping-bag"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <pickup-slot :siteSlug="siteSlug" v-else-if="error.length && enabledMenus.click_and_collect"></pickup-slot>

        <h5 v-else-if="menusFetched && !menus.length" class="text-center mt-5">
            {{ noMenuMessage }}
        </h5>
    </div>
</template>

<script>
import MenuSectionListing from "../../components/MenuSectionListing";
import Cart from "../../components/Cart";
import Navbar from "../../components/Navbar";
import Banner from '../../components/Banner';
import PickupSlot from '../../components/PickupSlot';

export default {
    components: { MenuSectionListing, Cart, Navbar, Banner, PickupSlot },
    data() {
        return {
            menus: [],
            menusFetched: false,
            siteSlug: this.$route.params.site,
            cart: window.app.cart,
            inactiveMessage: null,
            error: '',
            enabledMenus: window.app.enabled_menus,
            noMenuAvailableMessage: window.app.no_menu_available_message || {}
        }
    },
    computed: {
        noMenuMessage() {
            const fallback = this.$t("Unfortunately our menus are not currently available, please try again later.");

            if (!this.cart || !this.cart.variant) {
                return fallback;
            }

            return this.noMenuAvailableMessage[this.cart.variant] || fallback;
        }
    },
    methods: {
        fetch() {
            this.$axios
                .get(`/menus?site_slug=${this.siteSlug}`)
                .then(response => {
                    this.menus = response.data.items;
                    this.inactiveMessage = response.data.inactive_message;

                    this.checkForClickAndCollect();
                })
                .catch(error => {
                    if (error.response.status !== 400) {
                        this.$router.replace(`/error/${error.response.status}`);
                    } else {
                        this.error = error.response.data;
                    }
                }).then(() => {
                    this.menusFetched = true;
                });
        },
        checkForClickAndCollect() {
            if (this.cart && this.cart.variant == 'click-and-collect' && !this.menus.length) {
                window.location.href = `/${this.siteSlug}/select-slot`;
            }
        }
    },
    mounted() {
        this.fetch();

        if (Object.keys(this.enabledMenus).length == 1 && !this.cart) {
            window.location.href = `/${this.siteSlug}/${this.enabledMenus[Object.keys(this.enabledMenus)[0]]}`;
        }

        this.$pageTitle = this.$t("Menus");
    }
}
</script>
